import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Thumbs } from 'swiper/modules';


export default function initSwiper() {
  document.querySelectorAll('.swiper-click-next').forEach(el=> {
    const swiper = new Swiper(el, {
      // configure Swiper to use modules
      modules: [Navigation, Pagination, EffectFade],
      loop: true,
      speed: 600,
      effect: 'fade',
      fadeEffect: {
        crossFade: false
      },
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      breakpoints: {
        320: {
          allowTouchMove: true,
          mousewheel: true,
          allowSlidePrev: true,
          allowSlideNext: true,
        },
        1024: {
          allowTouchMove: false,
          mousewheel: false,
          allowSlidePrev: false,
          allowSlideNext: false,
        } 
      },
      on: {
        init: (api) =>{
          api.slides.forEach(slide=> {
            slide.addEventListener("click", () => {
              if(window.matchMedia('(min-width: 1024px)').matches) {
                api.allowSlideNext = true;
                api.slideNext();
                api.allowSlideNext = false;
              }
            });  
          });
          api.slides[0].classList.add('swiper-slide-animate');
          const observer = new IntersectionObserver(
            (entries, obs) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                if(entry.target.classList.contains('swiper-slide-animate')) {
                  entry.target.classList.remove('swiper-slide-animate');
                }
                if(!entry.target.classList.contains('has-animated')) {
                  entry.target.classList.add('has-animated');
                }
                obs.unobserve(api.slides[0]);
              });
            },
            { threshold: 0.1 }
          );

          observer.observe(api.slides[0]);
        },
        slideChange: (api,i)=> { 
          if(api.activeIndex == 0) return; 
          const slide = api.slides[api.activeIndex];
          if(!slide.classList.contains('has-animated')) { 
            setTimeout(()=> {
              slide.classList.add('has-animated');
            },300)
          }
        }
      }
    });
  });

  document.querySelectorAll('.cases').forEach(el=> {
    
    const elSwiper = el.querySelector('.cases-swiper');
    const elThumbs = el.querySelector('.cases-swiper-thumbs');
     var swiperThumbs = new Swiper(elThumbs, {
      spaceBetween: 0,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    });
     var swiper = new Swiper(elSwiper, {
      modules: [EffectFade, Thumbs],
      speed: 600,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: swiperThumbs,
      },
      on: {
        init: (api)=> {
          api.slides.forEach(slide=> {
            slide.addEventListener("click", () => {
              if(window.matchMedia('(min-width: 1024px)').matches) {
                api.slideNext();
              }
            });
          });
          
          api.slides[0].classList.add('swiper-slide-animate');
          const observer = new IntersectionObserver(
            (entries, obs) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                if(entry.target.classList.contains('swiper-slide-animate')) {
                  entry.target.classList.remove('swiper-slide-animate');
                }
                obs.unobserve(api.slides[0]);
              });
            },
            { threshold: 0.1 }
          );

          observer.observe(api.slides[0]);
        }
      }
      
    });
  });
}